import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { PAUSE } from 'redux-persist/es/constants';
import { PanSeedCheckRequestDataType, PanSeedCheckSuccessResponse } from '../components/common/types';
import { getRandomPanSeedCheckFolio } from '../components/common/utils';
import {
  NFT_TRXN_MAP_TYPE_VALUES,
  TRXN_TYPE_MAP,
  TRXN_MAP_TYPE_VALUES,
} from '../components/dashboard/commercial/utils';
import { panSeedCheck } from '../redux-store/actions/newPurchase';
import { IsAllow } from '../redux-store/types/portfolio';

export type PanSeedHookPropsType = {
  foliosArray?: Array<any>;
  callBackFn: (args?: any) => void;
  ignoreTrxnValid?: boolean;
  trxnType?: NFT_TRXN_MAP_TYPE_VALUES | TRXN_MAP_TYPE_VALUES;
  customPan?: string;
  trxnMode?: 'FT' | 'NFT';
  customPayload?: PanSeedCheckRequestDataType | null;
};

const usePanSeed = ({
  foliosArray,
  callBackFn,
  trxnType,
  customPan = '',
  trxnMode = 'NFT',
  customPayload = null,
  ignoreTrxnValid = false,
}: PanSeedHookPropsType) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const [open, setOpen] = useState(false);
  const [panSeedResponse, setPanseedResponse] =
    useState<PanSeedCheckSuccessResponse | null>(null);
  const [message, setMessage] = useState('');
  const [redirectPath, setRedirectPath] = useState('');
  const [shouldCheckPan, setShouldCheckPan] = useState(false);
  const [panSeedLoading, setLoading] = useState(false);

  function checkForErrors(panSeedResponse: PanSeedCheckSuccessResponse) {
    const { trxnAllowed, nomValid, fhPanAadharSeeded, nomRemarks, panSeededRemarks } =
      panSeedResponse;
    if (ignoreTrxnValid) {
      if (fhPanAadharSeeded !== IsAllow.YES) {
        setMessage(panSeededRemarks || "Please link your PAN & Aadhar to proceed with the transaction");
        setOpen(true);
      }
    } else if (trxnAllowed === IsAllow.No) {
      // if (nomValid === IsAllow.No) {
      //   setRedirectPath('/portal/nct/update-nominee');
      //   setMessage(nomRemarks);
      // } else 
      if (fhPanAadharSeeded !== IsAllow.YES) {
        setMessage(panSeededRemarks || "Please link your PAN & Aadhar to proceed with the transaction");
        setOpen(true);
      }
    }
  }

  const checkPanSeed = async (...args: any[]) => {
    try {
      setLoading(true);
      let data = customPayload
        ? { invName: '', invDob: '', ...customPayload }
        : foliosArray && trxnType
          ? {
            ...getRandomPanSeedCheckFolio(foliosArray, trxnType, trxnMode),
          }
          : null;
      // await $wait(1000)
      if (data) {
        // handle for sip pause/cancel, (better way to handle?)
        if (data.trxnType === TRXN_TYPE_MAP.sipPause) {
          const text = args[0].target.textContent || args[0].target.innerText;
          if (text !== PAUSE) {
            data = {
              ...data,
              trxnType: TRXN_TYPE_MAP.sipCancel,
            };
          }
        }
        const panSeedCheckResponse = await panSeedCheck({
          data: [data],
          ...(customPan && { pan: customPan }),
        })(dispatch);
        // success
        if (panSeedCheckResponse.body.success) {
          setPanseedResponse(panSeedCheckResponse.body.success[0]);
          if (panSeedCheckResponse.body.success[0].trxnAllowed !== IsAllow.No) {
            callBackFn(args);
          } else {
            checkForErrors(panSeedCheckResponse.body.success[0]);
            if (!ignoreTrxnValid) {
              if (data.trxnType === TRXN_TYPE_MAP.prospect || data.trxnType === TRXN_TYPE_MAP.newPurchase) {
                const { invNameValid, invDobValid, panSeededRemarks } = panSeedCheckResponse.body.success[0]
                callBackFn({ invNameValid, invDobValid, panSeededRemarks })
              }
            }
          }
        } else if (panSeedCheckResponse.body.errors) {
          const error = panSeedCheckResponse.body.errors[0];
          alert(error.message || error.techMessage);
          history.goBack();
          return;
        } else {
          alert("Unable to verify pan-aaadhar linking");
          return;
        }
      } else {
        throw new Error('Data is empty');
      }
    } catch (err: any) {
      alert(err.message);
      history.goBack();
    } finally {
      setLoading(false);
    }
  };

  return {
    checkPanSeed,
    shouldCheckPan,
    panSeedResponse,
    panSeedLoading,
    open,
    setOpen,
    message,
    redirectPath,
  };
};

export default usePanSeed;
